import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentMarriageContractMeta extends BaseEntityModel {
  parentId?: number;

  notaryFullName?: string;

  marriageContractDate?: string;

  marriageContractMinutes?: string;

  hasTestamentaryClause?: boolean;

  isTestamentaryClauseRevocable?: boolean;

  constructor(model: Partial<DocumentMarriageContractMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.notaryFullName = model.notaryFullName;
    this.marriageContractDate = model.marriageContractDate;
    this.marriageContractMinutes = model.marriageContractMinutes;
    this.hasTestamentaryClause = model.hasTestamentaryClause;
    this.isTestamentaryClauseRevocable = model.isTestamentaryClauseRevocable;
  }
}
